'use strict';

import * as Onyx from '../../lib/onyx.min.js';

import {default as FrameBufferTexture2DGodRays} from '../../shaders/caustic-blue';

const RETRY_TIMEOUT = 1000;

export default class ScenePreloader extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/preloader/index.html',
            clock: new Onyx.Clock()
        });

        this.complete = false;
    }

    onload(){
        super.onload();

        this.showBackgroundGraphics();

        this.progress = 0;

        centralStation.installDates(window.game.portalName, BUILD_DATE);
        // this.showBuildDateWarning(centralStation.buildDates());

        this.loadAssetsIndex((assets) => {
            // We're setting it to 1 because we want to count the config file
            let totalAssets = 1 + assets.images.length + assets.audio.music.length + assets.audio.sfx.length + assets.models.length;
            let totalLoaded = 1;

            this.preloadTextures(assets, (progress, remaining) => {
                this.showProgress((remaining + totalLoaded) / totalAssets);
            }, () => {
                totalLoaded += assets.images.length;

                this.preloadMusic(assets,  (progress, remaining) => {
                    this.showProgress((remaining + totalLoaded) / totalAssets);
                },() => {
                    totalLoaded += assets.audio.music.length;
                    this.preloadSFX(assets,  (progress, remaining) => {
                        this.showProgress((remaining + totalLoaded) / totalAssets);
                    },() => {
                        totalLoaded += assets.audio.sfx.length;
                        // this.showProgress(totalLoaded / totalAssets);
                        this.preloadModels(assets, (progress, remaining) => {
                            this.showProgress((remaining + totalLoaded) / totalAssets);
                        });
                    });
                });
            })
        });
    }

    update(...args){
        super.update(...args);

        if(this.complete || this.clock.stats.currentGameTime < 200000) return;

        // Update percent
        let currentPercent = document.getElementById("percent").innerHTML * 1;
        if(currentPercent < (this.progress * 100)){
            document.getElementById("percent").innerHTML = (currentPercent + 1);
        }

        if(currentPercent == 100 && !this.complete){
            this.complete = true;
            // return; // To halt at 100%
            document.getElementById("scene-preloader").classList.add("fade-out");
            this.setTimeout(() => {
                router.navigate('title');
            }, 2000);
        }
    }

    showBuildDateWarning(buildDates){
        var availableVersion = buildDates[window.game.name];
        if( availableVersion !== BUILD_DATE){
            document.getElementById('build-date-alert').innerHTML = "version "+availableVersion+" is available";
            document.getElementById('build-date-warning').style.display = 'block';
        }
    }

    showBackgroundGraphics(){
        this.camera = new Onyx.Camera();
        this.add(this.camera);
        this.viewports[0].bindToCamera(this.camera);

        let precision = this.viewports[0].webgl.getShaderPrecisionFormat(this.viewports[0].webgl.FRAGMENT_SHADER, this.viewports[0].webgl.HIGH_FLOAT);
        if(precision.rangeMax < 15){
            // Do nothing
        }else{
            this.godrays = new FrameBufferTexture2DGodRays();
            this.viewports[0].addFrameBufferTexture(this.godrays);
        }

        this.rays = new Onyx.Entity("rays", new Onyx.Model({
            meshes: [new Onyx.Mesh({
                material: new Onyx.MaterialPhong("", {
                    lighting: 0,
                    ambientTexture: this.godrays,
                    ambientTextureCoordinateSpace: "UV",
                    receivesFog: false
                })
            }).addPlane(1920, 1080)]
        }));

        this.rays.transform.translateTo(0, 0, 10);

        this.add(this.rays);
    }

    loadAssetsIndex(callback) {
        var xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open('GET', 'res/index.json', true);

        xobj.onreadystatechange = function() {
            if (xobj.readyState == 4 && xobj.status == "200") {
                // Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
                callback(JSON.parse(xobj.responseText));
            }
        };
        xobj.send(null);
    }

    preloadModels(assets, progressCallback, completeCallback) {
        let pending = 0;
        let failed = false;

        for(var i = 0; i < assets.models.length; i++){
            pending++;

            var filetype = assets.models[i].split(".").pop().toLowerCase();

            switch(filetype){
                case "oxm":
                    var importer = Onyx.ImportModelFromOnyx;
                    break;
                case "fbx":
                    var importer = Onyx.ImportModelFromFBX;
                    break;
                case "obj":
                default:
                    var importer = Onyx.ImportModelFromOBJ;
                    break;
            }

            importer.load({src: assets.models[i]}).then((model) => {
                pending--;

                if(progressCallback){
                    let percent = (assets.models.length - pending) / assets.models.length;
                    progressCallback(percent, assets.models.length - pending);
                }

                if (!pending) {
                    if(completeCallback) completeCallback();
                }
            }, () => {
                if(failed) return;
                failed = true;

                window.setTimeout(() => {
                    this.preloadModels(assets, progressCallback, completeCallback);
                }, RETRY_TIMEOUT);
            });
        }
    }

    preloadTextures(assets, progressCallback, completeCallback) {
		var preloader = new Onyx.Preloader();

        preloader.preloadTextures(assets.images, progressCallback).then(() => {
            if(completeCallback) completeCallback();
        }).catch((e) => {
            console.log(e);
            window.setTimeout(() => {
                this.preloadTextures(assets, progressCallback, completeCallback);
            }, RETRY_TIMEOUT);
        });
    }

    preloadMusic(assets, progressCallback, completeCallback) {
        let pending = 0;
        let failed = false;

        for(var i = 0; i < assets.audio.music.length; i++){
            pending++;

            var musicName = assets.audio.music[i].split("/").pop().replace(".mp3", "");
            game.music[musicName] = new Howl({
                src: [assets.audio.music[i]],
                // volume: 0.5,
                html5: false,
                loop: true,
                onload: () => {
                    pending--;

                    if(progressCallback){
                        let percent = (assets.audio.music.length - pending) / assets.audio.music.length;
                        progressCallback(percent, assets.audio.music.length - pending);
                    }

                    if (!pending) {
                        if(completeCallback) completeCallback();
                    }
                },
                onloaderror: () => {
                    if(failed) return;
                    failed = true;

                    window.setTimeout(() => {
                        this.preloadMusic(assets, progressCallback, completeCallback);
                    }, RETRY_TIMEOUT);
                }
            });
        }
    }

    preloadSFX(assets, progressCallback, completeCallback) {
        let pending = 0;
        let failed = false;

        for(var i = 0; i < assets.audio.sfx.length; i++){
            pending++;

            var sfxName = assets.audio.sfx[i].split("/").pop().replace(".mp3", "");
            game.sfx[sfxName] = new Howl({
                src: [assets.audio.sfx[i]],
                volume: 0.1,
                onload: () => {
                    pending--;

                    if(progressCallback){
                        let percent = (assets.audio.sfx.length - pending) / assets.audio.sfx.length;
                        progressCallback(percent, assets.audio.music.length - pending);
                    }

                    if (!pending) {
                        if(completeCallback) completeCallback();
                    }
                },
                onloaderror: () => {
                    if(failed) return;
                    failed = true;

                    window.setTimeout(() => {
                        this.preloadSFX(assets, progressCallback, completeCallback);
                    }, RETRY_TIMEOUT);
                }
            });
        }
    }

    showProgress(percent){
        // console.log(percent);
        this.progress = percent;
        // document.getElementById("percent").innerHTML = Math.floor(this.progress * 100) + "%";
    }
}
